import { GET_CURRENT_OWNER_QUERY } from '../../integrations/allkort/graphql/gql/OwnerQueries';
import { CurrentOwner, CurrentOwnerResponse } from '../../integrations/allkort/graphql/interface/Owner';
import { useGetCustomer } from './useGetCustomer';

/**
 * Hook for fetching current owner details.
 * Owner data is stable so cache-first is used.
 *
 * Usage:
 * const { owner, loading, error } = useGetCurrentOwner();
 *
 * @returns Object with owner data, loading state, and error
 */
export const useGetCurrentOwner = () => {
	const { data, loading, error } = useGetCustomer<CurrentOwnerResponse>(
		GET_CURRENT_OWNER_QUERY,
		undefined,
		{ fetchPolicy: 'cache-first' }
	);

	const owner: CurrentOwner | null = data?.currentOwner ?? null;

	return { owner, loading, error };
};
